import { render, staticRenderFns } from "./UserProfileAccount.vue?vue&type=template&id=1df1689c&scoped=true"
import script from "./UserProfileAccount.vue?vue&type=script&lang=js"
export * from "./UserProfileAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df1689c",
  null
  
)

export default component.exports